import styled, { keyframes } from 'styled-components';

const viewDeskLogo = keyframes`
	from {
    transform: translateY(-200%);
  }
  to {
    transform: translateY(0);
  }
`;

export const StyledSvg = styled.svg`
    margin-bottom: ${({ margin }) => margin};
    animation: ${viewDeskLogo} 1.5s ease;
    @media screen and (max-width: 576px) {
        display: none;
    }
`;

export const Link = styled.a`
    text-decoration: none;
    cursor: pointer;
`;
